// components/ProfilePicture.tsx
import { PLACEHOLDER_IMG_URL } from '../helpers/HelperConstants';
import React from 'react';

interface ProfilePictureProps {
  src?: string;
  alt?: string;
  onClick?: () => void;
}

const ProfilePicture: React.FC<ProfilePictureProps> = ({
  src = PLACEHOLDER_IMG_URL,
  alt = 'User profile',
  onClick,
}) => {
  return (
    <img
      className="profile-pic"
      src={src}
      alt={alt}
      onClick={onClick}
      referrerPolicy="no-referrer"
    />
  );
};

export default ProfilePicture;
